import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';

const ClearButton = ({ onClear, triggerTrackingEvent = () => {} }) => {
	const labels = useLabels();
	const onClearHandler = () => {
		triggerTrackingEvent({
			element: 'clear button',
			result: 'search field cleared'
		});
		onClear();
	};

	return (
		<button
			type="button"
			onClick={onClearHandler}
			aria-label={labels.get('CLEAR_SEARCH_INPUT')}
			className="text-link mx-3 my-0 ddc-font-size-xsmall text-input text-decoration-none"
		>
			{labels.get('CLEAR')}
		</button>
	);
};

ClearButton.propTypes = {
	onClear: PropTypes.func.isRequired,
	triggerTrackingEvent: PropTypes.func
};

export default ClearButton;
